<template>
  <a-drawer
    :visible="visible"
    placement="right"
    :mask-closable="true"
    :destroy-on-close="true"
    :body-style="{ height: 'calc(100% - 50px)', 'padding': '0' }"
    width="480"
    @close="closeHandler"
  >
    <template #title>
      <div class="title">
        <IconFont
          type="iconfupanzongjie"
          class="icon"
        />
        {{ `${$t('weekly.commentWeekly')}-${weeklyDetail?.weekDate}` }}
      </div>
    </template>
    <content
      v-bind="$attrs"
      :weekly-detail="weeklyDetail"
      @cancel="emit('update:visible', false)"
    />
  </a-drawer>
</template>
<script setup>
import { defineEmits } from 'vue'
import Content from './content.vue'
const emit = defineEmits(['update:visible'])
defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  weeklyDetail: {
    type: Object,
    default: () => {}
  }
})
const closeHandler = () => {
  emit('update:visible', false)
}
</script>
<style lang="less" scoped>
.title {
  display: flex;
  align-items: center;
  line-height: 32px;
}
.icon {
  margin-right: 8px;
}
.tip {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.56);
  margin-bottom: 4px;
  padding-left: 10px;
}
.tip-main {
  padding-bottom: 12px;
}

:deep(.ant-form-item-label){
  label {
    font-weight: 700;
  }
}

.drawer{
  .ant-drawer-header{
    position: sticky;
    top: 0;
  }
  :deep(.ant-drawer-body){
    height: calc(100% - 50px)
  }
}
</style>
